import { ScreenCompanyRegularSync } from '@dms/screen'

export default ScreenCompanyRegularSync
